import { TagSchema } from '@interfaces/product'
import { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'
import secureLocalStorage from 'react-secure-storage'

export const useGetShopTags = (shopId: string, filter: any = null) => {
  //?limit=nolimit
  let queryString = 'limit=nolimit'
  if (filter && filter.limit) {
    queryString = `limit=${filter.limit}`
  }
  if (filter) {
    queryString = Object.keys(filter)
      .map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(filter[key])
      })
      .join('&')
  }
  const tags = secureLocalStorage.getItem('tags')
  const url: string = `${API_ENDPOINTS.GET_SHOP_TAGS(shopId)}${
    queryString && `?${queryString}`
  }`
  const { data, isError, isLoading } = useApi(url, tags && {fallBackData: tags})
  return {
    tags: data?.data,
    isLoading,
    isError,
  } as {
    tags: TagSchema[],
    isLoading: boolean,
    isError: any
  }
}
